<div class="page-wrapper">
    <app-bees-header></app-bees-header>

    <div class="stricky-header stricked-menu main-menu">
        <div class="sticky-header__content"></div><!-- /.sticky-header__content -->
    </div><!-- /.stricky-header -->



    <!--Page Header Start-->
    <section class="page-header">
        <div class="page-header__bg" style="background-image: url(assets/images/backgrounds/page-header-bg.jpg);">
        </div>
        <div class="container">
            <div class="page-header__inner">
                <div class="page-header__img-1">
                    <img src="assets/images/resources/page-header-img-1.png" alt="">
                </div>
                <div class="page-header__shape-1 float-bob-y">
                    <img src="assets/images/shapes/page-header-shape-1.png" alt="">
                </div>
                <h3>About Us</h3>
                <div class="thm-breadcrumb__inner">
                    <ul class="thm-breadcrumb list-unstyled">
                        <li><a href="index.html">Home</a></li>
                        <li><span class="fas fa-angle-right"></span></li>
                        <li>About Us</li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
    <!--Page Header End-->

    <!--About One Start-->
    <section class="about-one">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="about-one__left wow slideInLeft" data-wow-delay="100ms" data-wow-duration="2500ms">
                        <div class="about-one__img-box">
                            <div class="about-one__img">
                                <img src="assets/images/resources/x4.png" alt="">
                            </div>
                            <div class="about-one__review-and-experience-box">
                                <div class="about-one__review-box">
                                    <ul class="list-unstyled about-one__review-list">
                                        <li>
                                            <div class="about-one__review-img">
                                                <img src="assets/images/resources/about-one-review-img-1-1.jpg" alt="">
                                            </div>
                                        </li>
                                        <li>
                                            <div class="about-one__review-img">
                                                <img src="assets/images/resources/about-one-review-img-1-2.jpg" alt="">
                                            </div>
                                        </li>
                                        <li>
                                            <div class="about-one__review-img">
                                                <img src="assets/images/resources/about-one-review-img-1-3.jpg" alt="">
                                            </div>
                                        </li>
                                        <li>
                                            <div class="about-one__review-img">
                                                <img src="assets/images/resources/about-one-review-img-1-4.jpg" alt="">
                                            </div>
                                        </li>
                                    </ul>
                                    <div class="about-one__review-star">
                                        <span class="fas fa-star"></span>
                                        <span class="fas fa-star"></span>
                                        <span class="fas fa-star"></span>
                                        <span class="fas fa-star"></span>
                                        <span class="fas fa-star"></span>
                                    </div>
                                    <p class="about-one__review-text">Clients 100+</p>
                                </div>
                                <div class="about-one__experience-box">
                                    <div class="about-one__experience-count">
                                        <h3 class="odometer" data-count="5">35</h3>
                                        <span>+</span>
                                    </div>
                                    <p class="about-one__experience-count-text">Years Of <br> Experience</p>
                                </div>
                                <div class="about-one__video-link">
                                    <a href="#" class="video-popup">
                                        <div class="about-one__video-icon">
                                            <span class="fa fa-play"></span>
                                            <i class="ripple"></i>
                                        </div>
                                    </a>
                                    <h4 class="about-one__video-title">Watch Video</h4>
                                </div>
                            </div>
                            <div class="about-one__circle-text">
                                <div class="about-one__round-text-box">
                                    <div class="inner">
                                        <div class="about-one__curved-circle rotate-me">
                                     ★ Shingad Shipping Lines ★ Shingad Shipping Lines
                                        </div>
                                    </div>
                                    <div class="overlay-icon-box">
                                        <a href="about"><i class="icon-plane"></i></a>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="about-one__shape-1">
                                    <img src="assets/images/shapes/about-one-shape-1.png" alt="">
                                </div> -->
                            <!-- <div class="about-one__shape-2">
                                    <img src="assets/images/shapes/about-one-shape-2.png" alt="">
                                </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="about-one__right">
                        <div class="section-title text-left sec-title-animation animation-style2">
                            <div class="section-title__tagline-box">
                                <span class="section-title__tagline-border"></span>
                                <div class="section-title__shape-1">
                                    <i class="fas fa-plane"></i>
                                </div>
                                <h6 class="section-title__tagline">ABOUT US</h6>
                                <span class="section-title__tagline-border"></span>
                                <div class="section-title__shape-2">
                                    <i class="fas fa-plane"></i>
                                </div>
                            </div>
                            <h3 class="section-title__title title-animation">Shingad Shipping Lines <span>Private Limited

                                </span>
                            </h3>
                        </div>
                        <p class="about-one__text">
                          Shingad Shipping Lines Pvt Ltd is an MSME-registered Indian startup company based in Kerala, specializing in shipping, logistics, maritime consultancy, and international trade.
                            <br><br>
                          We are committed to exporting premium quality Kerala spices, hill , forest, and agricultural products to global markets with strict quality control, hygienic packaging, and international standards.
                            <br><br> 
                            
                            Shingad Shipping Lines Pvt Ltd provides reliable and efficient Ship Chandling Services to vessels calling at Indian ports. We supply a wide range of provisions, technical stores, deck and engine consumables, safety equipment, and bonded stores to merchant ships, offshore vessels, dredgers, research vessels, cruise ships, and naval support vessels.
  <br><br> 
                            
Our experienced team ensures timely delivery, quality products, competitive pricing, and compliance with port, customs, and maritime regulations.
                           
                        </p>
                        <div class="about-one__point-box">

                        </div>
                        <div class="about-one__point-box-two">
                            <ul class="about-one__point-two">
                                <li>
                                    <div class="icon">
                                        <span class="fas fa-check"></span>
                                    </div>
                                    <div class="text">
                                        <p>Shipping Logistics & Export / Imports</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="icon">
                                        <span class="fas fa-check"></span>
                                    </div>
                                    <div class="text">
                                        <p>Shipping & Maritime Operations</p>
                                    </div>
                                </li>
                            
                            </ul>
                            <ul class="about-one__point-two about-one__point-two--three">
                                <li>
                                    <div class="icon">
                                        <span class="fas fa-check"></span>
                                    </div>
                                    <div class="text">
                                        <p>Port and Hydrography</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="icon">
                                        <span class="fas fa-check"></span>
                                    </div>
                                    <div class="text">
                                        <p>Legal Services</p>
                                    </div>
                                </li>
                              
                            </ul> 
                        </div> 
                        <br>
  <p>  Shingad Shipping Lines Pvt Ltd is an MSME-registered Indian startup company based in Kerala, specializing in shipping, logistics, maritime consultancy, and international trade.</p>
                        <div class="about-one__btn-and-author-box">
                           
                            <div class="about-one__author-box">
                                <div class="about-one__author-details">
                                    <div class="about-one__author-img-box">
                                        <div class="about-one__author-img">
                                            <img src="assets/images/team/team-1-1.jpg" alt="">
                                        </div>
                                    </div>
                                    <div class="about-one__author-content">
                                        <h4> Adv. K.j.Thomas </h4>
                                        <p>Founder</p>
                                    </div>
                                </div>

                            </div>

                          
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--About One End-->


 

    <!--Find Transport Start -->
    <section class="find-transport mt-5">
        <div class="find-transport__shape-bg"
            style="background-image: url(assets/images/shapes/find-transport-shape-bg.png);"></div>
        <div class="container">
            <div class="find-transport__inner">
                <div class="find-transport__title-box">
                    <h3 class="find-transport__title">
  Looking for the Best
    <br> 
Maritime & Shipping Operation Service?
</h3>
                </div>
                <div class="find-transport__btn-and-call">
                    <div class="find-transport__call-us">
                        <div class="icon">
                            <span class="icon-phone-call"></span>
                        </div>
                        <div class="content">
                            <span>Call Us Free</span>
                            <p><a href="tel: 919447117399">+91 944 7117 399</a></p>
                        </div>
                    </div>
                    <div class="find-transport__btn-box">
                        <a href="contact" class="thm-btn">Contact Us</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--Find Transport End -->







    <app-bees-footer></app-bees-footer>




</div><!-- /.page-wrapper -->